var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-shimer"},_vm._l((_vm.bars),function(bar,index){return _c('ShimmerLoader',{key:index + '-' + bar,staticClass:"chart-shimer__shimer",class:'chart-shimer__shimer--' + bar})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }